const eventTypes = {
    reception: "Receptie",
    diner: "Diner & avondfeest",
    all: "Receptie, diner & avondfeest"
}

export default eventTypes;